import React from "react";
import Calendar from "react-calendar";
import { useDispatch, useSelector } from "react-redux";
import {
  setVolumeOverlayDate,
  setDefaultOverlayData,
  setPageLoading,
  setSimulatedVolumeOverlayData,
  setShowErrorModal,
  setErrorModalMessage,
  setOverlayTimeBand,
  setFullMapParcelList,
  setFullMapOverlayDate,
  setSimulationPercentage,
} from "../../../../reducers/app";
import { getParcelDataForFullMap, simulateData } from "../../../../utils/api";
import {
  activeDatesForAllocationDatePickerSelector,
  activeDatesForSimulationDatePickerSelector,
  fullMapOverlayDateSelector,
  pageToShowIndexSelector,
  volumeOverlayDateSelector,
} from "../../../../reducers/app/selector";
import { depotCodeSelector } from "../../../../reducers/depot/selector";
import "react-calendar/dist/Calendar.css";
import { formatDate } from "../../../../utils/formatDate";
import { checkFirstTimeBand } from "../../../../utils/map/timeBands";
import "./HeaderDatePicker.css";
import { DEFAULT_TIMEBAND } from "../../../../constants/timeBands";

const { REACT_APP_ORACLE_ENV } = process.env;

export const HeaderDatePicker = ({ activeDropDown, setActiveDropDown }) => {
  const dispatch = useDispatch();
  const volumeOverlayDate = useSelector(volumeOverlayDateSelector);
  const depotCode = useSelector(depotCodeSelector);
  const pageToShowIndex = useSelector(pageToShowIndexSelector);
  const activeSimulationDates = useSelector(
    activeDatesForSimulationDatePickerSelector
  );
  const activeAllocationDates = useSelector(
    activeDatesForAllocationDatePickerSelector
  );
  const fullMapOverlayDate = useSelector(fullMapOverlayDateSelector);

  const activeDates =
    pageToShowIndex === 0 ? activeSimulationDates : activeAllocationDates;

  const maxDate = activeDates[0]
    ? new Date(activeDates[activeDates.length - 1])
    : new Date();

  const minDate = activeDates[0] ? new Date(activeDates[0]) : new Date();

  const getSimulatedData = async (newDate) => {
    const formattedDate = formatDate(newDate);
    if (formattedDate !== volumeOverlayDate) {
      const defaultOverlayData = await simulateData(
        depotCode,
        formattedDate,
        0
      );
      dispatch(setSimulatedVolumeOverlayData(null));
      dispatch(setVolumeOverlayDate(formattedDate));
      if (defaultOverlayData.data.length < 1) {
        throw new Error();
      } else {
        dispatch(setDefaultOverlayData(defaultOverlayData.data));
      }
      dispatch(setSimulationPercentage(0));
      const firstBand = checkFirstTimeBand(
        "00:00:00",
        defaultOverlayData.data,
        formattedDate
      );
      dispatch(
        setOverlayTimeBand(
          firstBand > DEFAULT_TIMEBAND ? firstBand : DEFAULT_TIMEBAND
        )
      );
    }
  };

  const getPostcodeAllocationData = async (newDate) => {
    const formattedDate = formatDate(newDate);
    const fullMapParcelList = await getParcelDataForFullMap(formattedDate);
    dispatch(setFullMapOverlayDate(formattedDate));
    dispatch(setFullMapParcelList(fullMapParcelList.data));
  };

  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
      }}
      className={
        REACT_APP_ORACLE_ENV ? "oracleHeaderDatePicker" : "headerDatePicker"
      }
    >
      <Calendar
        onChange={async (newDate) => {
          dispatch(setPageLoading(true));
          setActiveDropDown("none");
          try {
            if (pageToShowIndex === 0) {
              await getSimulatedData(newDate);
            } else if (pageToShowIndex === 1) {
              await getPostcodeAllocationData(newDate);
            }

            dispatch(setPageLoading(false));
          } catch (err) {
            dispatch(setShowErrorModal(true));
            dispatch(setErrorModalMessage("Getting Overlay Data"));
            dispatch(setPageLoading(false));
          }
        }}
        defaultActiveStartDate={maxDate}
        value={
          new Date(
            pageToShowIndex === 0 ? volumeOverlayDate : fullMapOverlayDate
          )
        }
        isOpen={activeDropDown === "volume"}
        maxDate={maxDate}
        minDate={minDate}
        tileDisabled={({ date, view }) => {
          if (view === "month") {
            return !activeDates.includes(formatDate(date));
          } else {
            return false;
          }
        }}
      />
    </div>
  );
};
